import { Link } from 'react-router-dom';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import type { Game } from '../api/types';
import { GameCard } from './GameCard';

interface Props {
  title: string;
  games: Game[];
  seeAllTo?: string;
}

export function GameSectionRow({ title, games, seeAllTo = '/games' }: Props) {
  const { t } = useTranslation('common');
  const scroller = useRef<HTMLDivElement>(null);

  function scrollBy(dir: -1 | 1) {
    const el = scroller.current;
    if (!el) return;
    el.scrollBy({ left: dir * Math.max(240, el.clientWidth * 0.7), behavior: 'smooth' });
  }

  if (games.length === 0) return null;

  return (
    <section className="game-section">
      <div className="game-section-head">
        <h2>{title}</h2>
        <div className="game-section-actions">
          <Link to={seeAllTo} className="btn btn-ghost btn-compact">
            {t('seeAll')}
          </Link>
          <button type="button" className="icon-btn" aria-label="Prev" onClick={() => scrollBy(-1)}>
            ‹
          </button>
          <button type="button" className="icon-btn" aria-label="Next" onClick={() => scrollBy(1)}>
            ›
          </button>
        </div>
      </div>
      <div className="game-section-track" ref={scroller}>
        {games.map((game) => (
          <div key={game.id} className="game-section-item">
            <GameCard game={game} dense />
          </div>
        ))}
      </div>
    </section>
  );
}
